// extracted by mini-css-extract-plugin
export default {"App":"App_App__kSMra","appLogo":"App_appLogo__E8MCV","profileLogo":"App_profileLogo__RuCus","authMain":"App_authMain__8eDyR","main":"App_main__Yy1tt"};